var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 8.33268H5.83341C7.50008 8.33268 8.33341 7.49935 8.33341 5.83268V4.16602C8.33341 2.49935 7.50008 1.66602 5.83341 1.66602H4.16675C2.50008 1.66602 1.66675 2.49935 1.66675 4.16602V5.83268C1.66675 7.49935 2.50008 8.33268 4.16675 8.33268Z",
    stroke: "#3F4254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 8.33268H15.8334C17.5001 8.33268 18.3334 7.49935 18.3334 5.83268V4.16602C18.3334 2.49935 17.5001 1.66602 15.8334 1.66602H14.1667C12.5001 1.66602 11.6667 2.49935 11.6667 4.16602V5.83268C11.6667 7.49935 12.5001 8.33268 14.1667 8.33268Z",
    stroke: "#3F4254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3327H15.8334C17.5001 18.3327 18.3334 17.4993 18.3334 15.8327V14.166C18.3334 12.4993 17.5001 11.666 15.8334 11.666H14.1667C12.5001 11.666 11.6667 12.4993 11.6667 14.166V15.8327C11.6667 17.4993 12.5001 18.3327 14.1667 18.3327Z",
    stroke: "#3F4254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 18.3327H5.83341C7.50008 18.3327 8.33341 17.4993 8.33341 15.8327V14.166C8.33341 12.4993 7.50008 11.666 5.83341 11.666H4.16675C2.50008 11.666 1.66675 12.4993 1.66675 14.166V15.8327C1.66675 17.4993 2.50008 18.3327 4.16675 18.3327Z",
    stroke: "#3F4254",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.6cdb50b00072cb402c60816c74d96c4b.svg";
export { ForwardRef as ReactComponent };